import {useContext} from 'react'
import {CarouselContext} from '../context'

const useContainerWidth = (): number => {
  const {containerWidth} = useContext(CarouselContext)

  return containerWidth
}

export default useContainerWidth
